






























































































































































































import { mapState } from "vuex";
import FormCount from "@/common/components/organisms/FormCount.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import InputSelect from "@/common/components/atoms/InputSelect.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconFavorite40px from "@/common/components/icons/IconFavorite40px.vue";
import IconCart from "@/common/components/icons/IconCart.vue";
import TheC01ItemFormNotePanelShortage from "@/general/components/pages/parts/ProductDetails/TheC01ItemFormNotePanelShortage.vue";
import TheC01ItemFormNotePanelDrink from "@/general/components/pages/parts/ProductDetails/TheC01ItemFormNotePanelDrink.vue";
import TheC01ItemFormNotePanelGiftCard from "@/general/components/pages/parts/ProductDetails/TheC01ItemFormNotePanelGiftCard.vue";
import TheC01ItemFormOnlyTypeInCart from "@/general/components/pages/parts/ProductDetails/TheC01ItemFormOnlyTypeInCart.vue";
import C01ItemFormExtraProp from "@/general/components/pages/parts/ProductDetails/C01ItemFormExtraProp.vue";

import { Prop, Watch, Vue, Component, Ref } from "vue-property-decorator";
import items from "@/general/store/modules/items";
import TheHeaderUserNavi from "@/common/components/organisms/header/TheHeaderUserNavi.vue";
import {
  getShoppingCartItems,
  patchItemfromShoppingcart,
  postBrowserHistory,
  postShoppingCartItems
} from "@/general/store/api";
import {
  PatchedShoppingCartItemRequest,
  ShoppingCartItemRequest
} from "gen/ricapi/api";
import { BrowsingHistoryRequest } from "gen/rssapi/api";

import ValidationErrorText from "@/common/components/atoms/ValidationErrorText.vue";
import { extend, ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email, max, min } from "vee-validate/dist/rules";
import LocalStorage from "@/general/utils/storage";

extend("required", {
  ...required,
  message: "{_field_}を入力してください。"
});

extend("regex", {
  message(field, data) {
    return `${field} を入力してください。`;
  },
  validate(value, args: any) {
    const regEx = new RegExp(args[0]);
    return regEx.test(value);
  }
});

extend("max", {
  ...max,
  message: "{_field_}は{length}文字以内を入力してください。"
});

extend("min", {
  ...min,
  message: "{_field_}は{length}文字以内を入力してください。"
});

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
    FormCount,
    ButtonMain,
    InputSelect,
    IconBase,
    IconFavorite40px,
    IconCart,
    TheC01ItemFormNotePanelShortage,
    TheC01ItemFormNotePanelDrink,
    TheC01ItemFormNotePanelGiftCard,
    C01ItemFormExtraProp,
    ValidationErrorText,
    TheC01ItemFormOnlyTypeInCart
  }
})
export default class TheC01ItemForm extends Vue {
  @Prop({
    type: Array,
    required: false,
    default: () => {
      return [];
    }
  })
  options!: any;
  @Prop({
    type: Array,
    required: false,
    default: () => {
      return [];
    }
  })
  optionTypes!: any;
  @Prop({ type: Boolean, required: true, default: false }) isFavorite!: any;
  @Prop({ type: Number, required: true, default: 0 }) point!: any;
  @Prop({ type: Number, required: true, default: 0 }) stock!: any;
  @Prop({ type: String, required: true, default: "" }) jan_code!: any;
  @Prop({ type: String, required: true, default: "normal" }) type!: any;
  @Prop({
    type: [Array, Object],
    required: false,
    default: () => {
      return {};
    }
  })
  extraProp!: any;
  @Prop({
    type: Array,
    required: false,
    default: () => {
      return [];
    }
  })
  cartItem!: any;
  @Prop({ type: Number, required: true, default: 0 }) possession!: any;
  @Prop({ type: Boolean, required: false }) creditCardEnabled!: any;
  @Prop({ type: Boolean, required: true }) ageAlert!: boolean;
  @Prop({ type: [String, Number], required: true }) id!: number | string;
  @Prop({ type: Boolean, required: true }) isQuantityControl!: boolean;
  @Prop({ type: Array, required: false }) clientList!: any;
  @Prop({ type: Boolean, required: true }) isBenepoExchange!: boolean;
  @Prop({ type: String, required: false, default: "" }) saleEndDate!: string;
  @Prop({ type: Boolean, required: true, default: false })
  isHiddenItem!: boolean;

  @Ref("form") form!: HTMLFormElement;

  allOptions: any = [];
  size = "";
  color = "";
  count = 1;
  isAdult = false;
  extraPropValue = "";
  extraPropSecondValue = "";
  extraPropThirdValue = "";
  blankString = "";
  flag: any = [];
  cartItemId = 0;
  cartItemQty = 0;
  skuId = 0;
  clientListOption = "";
  itemOptions: any = [];

  get hasStock() {
    return (
      !this.isQuantityControl || (this.isQuantityControl && this.stock > 0)
    );
  }
  get haveExtraProps() {
    return this.extraProp.length > 0;
  }

  get isOnlyTypeInCart() {
    return this.cartItem.length > 0;
  }

  get maxStock() {
    return this.type == "web_coupon" ? 1 : this.stock;
  }

  get isGiftCardAndNormalItemInCart() {
    const isGiftCard = this.type === "gift_card";
    const hasNormalItemInCart = this.cartItem.some(
      (item: any) => item.sku_data.redemption_type === 1
    );
    return (
      isGiftCard && hasNormalItemInCart && this.stock > 0 && this.possession > 0
    );
  }

  get isWebCouponAndGiftItemInCart() {
    const isGiftCard = this.type === "web_coupon";
    const hasNormalItemInCart = this.cartItem.some(
      (item: any) => item.sku_data.redemption_type === 2
    );
    return (
      isGiftCard && hasNormalItemInCart && this.stock > 0 && this.possession > 0
    );
  }

  get isGiftCardAndWebCouponItemInCart() {
    const isGiftCard = this.type === "gift_card";
    const hasNormalItemInCart = this.cartItem.some(
      (item: any) => item.sku_data.redemption_type === 3
    );
    return (
      isGiftCard && hasNormalItemInCart && this.stock > 0 && this.possession > 0
    );
  }

  get isWebCouponAndNormalItemInCart() {
    const isGiftCard = this.type === "web_coupon";
    const hasNormalItemInCart = this.cartItem.some(
      (item: any) => item.sku_data.redemption_type === 1
    );
    return (
      isGiftCard && hasNormalItemInCart && this.stock > 0 && this.possession > 0
    );
  }

  get isNormalItemAndGiftCardInCart() {
    const isNormalItem = this.type === "normal";
    const hasGiftCardInCart = this.cartItem.some(
      (item: any) => item.sku_data.redemption_type !== 1
    );
    return (
      isNormalItem && hasGiftCardInCart && this.stock > 0 && this.possession > 0
    );
  }

  get isBenepoExchangeAndSomethingsInCart() {
    const isBenepoExchage = this.isBenepoExchange;
    const haveSomethingsInCart = this.cartItem.length !== 0;
    console.log(isBenepoExchage);
    console.log(haveSomethingsInCart);
    console.log(this.stock);
    console.log(this.possession);
    return isBenepoExchage && haveSomethingsInCart;
  }

  get isLiquor() {
    return this.type === true;
  }
  get isDrinkStop() {
    return this.ageAlert && !this.isAdult;
  }

  get isSkuSelected() {
    return this.skuId != 0;
  }
  get favoriteLabel() {
    return this.isFavorite ? "お気に入りから外す" : "お気に入りに追加";
  }
  get isShortage() {
    const total = this.point * this.count;
    const shortage = this.possession > 0 && this.possession < total;
    return this.hasStock && shortage;
  }

  get productRequiredpoints() {
    return this.point * this.count;
  }

  get isCreditCardEnabledAndItemInCart() {
    const creditCardEnabled = this.creditCardEnabled;
    const cartItemCount = this.cartItem.length > 0;
    const count = this.count != 1;
    return creditCardEnabled && (cartItemCount || count);
  }

  get cartEmpty() {
    return this.cartItem.length == 0;
  }

  get userPointsAreGreaterThanProductPoint() {
    const userPoints = this.possession;
    const productRequiredpoints = this.productRequiredpoints;
    return userPoints >= productRequiredpoints;
  }

  get compareSaleEndDate() {
    if (this.saleEndDate == "") {
      return true;
    }
    const endDate = new Date(this.saleEndDate);
    const today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    return endDate >= today;
  }

  get disabled() {
    if (this.skuId == 0) {
      return true;
    }
    if (this.isOnlyTypeInCart) {
      return true;
    }
    if (this.hasStock) {
      if (!this.isQuantityControl || this.stock >= this.count) {
        if (this.isDrinkStop) {
          return true;
        }
        if (this.possession >= this.productRequiredpoints) {
          //credit card not required
          if (this.cartItem.length > 0) {
            if (
              this.isBenepoExchangeAndSomethingsInCart ||
              this.isGiftCardAndNormalItemInCart ||
              this.isNormalItemAndGiftCardInCart ||
              this.isWebCouponAndGiftItemInCart ||
              this.isGiftCardAndWebCouponItemInCart ||
              this.isWebCouponAndNormalItemInCart
            ) {
              console.log("gift and normal condition failed");
              return true;
            } else {
              console.log("gift and normal condition passed");
              return false;
            }
          } else {
            console.log(" cart is empty");
            return false;
          }
        } else {
          if (this.possession < 1) {
            console.log("user points are 0");
            return true;
          }
          //credit required
          if (this.creditCardEnabled) {
            if (this.cartItem.length > 0 || this.count != 1) {
              // console.log("credit card not allowed because cart is not empty or count is not equal to 1 ");
              return true;
            } else {
              if (this.type !== "gift_card") {
                console.log("credit card allowed because cart is empty");
                return false;
              } else {
                console.log("credit card allowed because product is gift card");
                return true;
              }
            }
          } else {
            console.log("credit card is disabled");
            return true;
          }
        }
      } else {
        console.log("stock is less than count selected");
        return true;
      }
    } else {
      console.log("No stock Available");
      return true;
    }
  }

  @Watch("options")
  onOptionChange() {
    if (
      this.options &&
      this.options.length > 0 &&
      this.optionTypes.length == 0
    ) {
      this.skuId = this.options[0].id;
      this.options[0].options.forEach((ele: any) => {
        this.flag.push(ele.id.toString());
      });
    }
  }

  favorite() {
    this.$emit("favorite", this.skuId);
  }
  unfavorite() {
    this.$emit("unfavorite", this.skuId);
  }
  changeFavorite() {
    this.isFavorite ? this.unfavorite() : this.favorite();
  }
  onCheckAdult() {
    this.isAdult = !this.isAdult;
  }

  getCartItemCount() {
    const cartItems = this.getCartItems();
    return cartItems.length;
  }

  getCartItems() {
    return JSON.parse(LocalStorage.getItem("cartDetails") as string);
  }

  getUserDetails() {
    return JSON.parse(LocalStorage.getItem("userDetails") as string);
  }

  submit(ObserverProps: any) {
    ObserverProps.passes(async () => {
      const userDetails = this.getUserDetails();

      const sku = this.options.find((element: any) => {
        return element.options.every(
          (e: any, i: any) => e.value == this.flag[i]
        );
      });

      if (sku !== undefined) {
        this.skuId = sku.id;
      } else {
        window.alert("オプションは利用できません");
        return;
      }

      const browserHistoryRequest: BrowsingHistoryRequest = {
        user: userDetails.id,
        sku: this.skuId
      };
      await postBrowserHistory(browserHistoryRequest);

      const cartItems = await getShoppingCartItems(1, 90, "");

      const itemExist = cartItems?.results?.find((item: any) => {
        return item.sku_id == this.skuId;
      });

      if (itemExist !== undefined) {
        this.cartItemId = itemExist.id;
        this.cartItemQty = itemExist.quantity;

        const PatchedShoppingCartItemRequest: PatchedShoppingCartItemRequest = {
          user: userDetails.id,
          sku_id: this.skuId,
          quantity: this.count + this.cartItemQty,
          option_type_extra: this.sortedExtraOptions,
          customer_no:
            this.clientListOption.length > 0
              ? this.clientListOption.split(",")[0]
              : "",
          torino_no:
            this.clientListOption.length > 0
              ? this.clientListOption.split(",")[1]
              : ""
        };

        const res = await patchItemfromShoppingcart(
          this.cartItemId,
          PatchedShoppingCartItemRequest
        ).catch(async (error: any) => {
          alert(error.response.data);
          window.location.reload();
        });

        if (res) {
          this.form.submit();
        }
      } else {
        const shoppingCartItemRequest: ShoppingCartItemRequest = {
          user: userDetails.id,
          sku_id: this.skuId,
          quantity: this.count,
          option_type_extra: this.itemOptions.concat(this.sortedExtraOptions),
          customer_no:
            this.clientListOption.length > 0
              ? this.clientListOption.split(",")[0]
              : "",
          torino_no:
            this.clientListOption.length > 0
              ? this.clientListOption.split(",")[1]
              : ""
        };
        const res = await postShoppingCartItems(shoppingCartItemRequest).catch(
          (error: any) => {
            alert(error.response.data);
            window.location.reload();
          }
        );

        if (res) {
          this.form.submit();
        }
      }
    });
  }

  getOptions(id: number) {
    const allOptions: any = [];
    const checkDuplicateValues: any = [];
    this.options.forEach((item: any) => {
      item.options.forEach((ele: any) => {
        if (ele.option_type == id) {
          if (checkDuplicateValues.indexOf(ele.value) == -1) {
            allOptions.push({ label: ele.value, value: ele.value });
            checkDuplicateValues.push(ele.value);
          }
        }
      });
    });
    return allOptions;
  }

  onChangeSelect(key: any, optionId: number, optionName: any) {
    const skuId = this.options[0].id;
    if (this.itemOptions.length === 0) {
      this.itemOptions.push({
        id: optionId,
        sku: skuId !== undefined ? skuId : "-",
        name: optionName,
        value: key
      });
    } else if (this.itemOptions.length !== this.optionTypes.length) {
      this.itemOptions.forEach(
        (itemOption: { id: number; sku: any; name: any; value: any }) => {
          if (itemOption.id === optionId) {
            itemOption.value = key;
          } else if (itemOption.id !== optionId) {
            this.itemOptions = this.itemOptions.concat([
              {
                id: optionId,
                sku: skuId !== undefined ? skuId : "-",
                name: optionName,
                value: key
              }
            ]);
          }
        }
      );
    } else if (this.itemOptions.length === this.optionTypes.length) {
      this.itemOptions = this.itemOptions.map(
        (itemOption: { id: number; sku: any; name: any; value: any }) =>
          itemOption.id === optionId
            ? {
                id: optionId,
                sku: skuId !== undefined ? skuId : "-",
                name: optionName,
                value: key
              }
            : itemOption
      );
    }
    if (this.flag.length == this.optionTypes.length) {
      const sku = this.options.find((element: any) => {
        return element.options.every(
          (e: any, i: any) => e.value == this.flag[i]
        );
      });
      if (sku !== undefined) {
        this.skuId = sku.id;
        this.$emit("update:point", sku.point_required);
        this.$emit(
          "update:stock",
          sku.is_quantity_control ? sku.quantity : 9999
        );
        this.$emit("update:is-quantity-control", sku.is_quantity_control);
        this.$emit("update:jan_code", sku.jan_code);
        this.$emit("update:isFavorite", sku.is_favorite);
        this.$emit("update:extra-prop", sku.optiontypeextra_set);

        if (
          sku.optiontypeextra_set &&
          sku.optiontypeextra_set.length > 0 &&
          sku.optiontypeextra_set[0].name ==
            "私は20歳以上です（はいorいいえ）" &&
          sku.optiontypeextra_set[0].regex == "^はい$"
        ) {
          this.$emit("update:age-alert", true);
        } else {
          this.$emit("update:age-alert", false);
        }
      } else {
        this.skuId = 0;
      }
    }
  }

  sortByKey(array: any, key: any) {
    return array.sort(function(a: any, b: any) {
      const x = a[key];
      const y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }

  get sortedExtraOptions() {
    return this.sortByKey(this.extraProp, "display_order").map((ele: any) => {
      return {
        ...ele,
        value: "",
        sku: ele.sku.toString(),
        regex: ele.regex != null ? ele.regex : ""
      };
    });
  }
}
